import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const OFFER_END = new Date("2026-09-03T20:00:00-03:00").getTime();

export const Countdown = ({ compact = false }) => {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);
  const diff = OFFER_END - now;

  if (diff <= 0) {
    return (
      <p data-testid="countdown-48hs-ended" className="text-[11px] font-medium uppercase tracking-[0.25em] text-ash">
        La oferta finalizó
      </p>
    );
  }

  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);
  const pad = (n) => String(n).padStart(2, "0");

  if (compact) {
    return (
      <p
        data-testid="countdown-48hs-compact"
        className="text-[11px] font-medium uppercase tracking-[0.22em] text-gold"
      >
        La oferta termina en {d > 0 && `${d} ${d === 1 ? "día" : "días"}, `}
        {pad(h)}:{pad(m)}:{pad(s)}
      </p>
    );
  }

  return (
    <div data-testid="countdown-48hs" className="flex items-start justify-center gap-6">
      {[
        [d, d === 1 ? "día" : "días"],
        [h, "hs"],
        [m, "min"],
        [s, "seg"],
      ].map(([v, label], i) => (
        <div key={label} className="flex items-start gap-6">
          {i > 0 && <span className="font-serif text-2xl text-crimson-light/60">·</span>}
          <div className="text-center">
            <p className="font-serif text-3xl tabular-nums text-gold">{pad(v)}</p>
            <p className="mt-1 text-[9px] font-medium uppercase tracking-[0.25em] text-ash">{label}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export const Reveal = ({ children, delay = 0, className = "", y = 30 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionTag = ({ children, dark = true }) => (
  <p
    className={`font-sans text-xs font-medium uppercase tracking-[0.3em] ${
      dark ? "text-gold" : "text-crimson"
    }`}
  >
    {children}
  </p>
);

export const SectionTitle = ({ children, dark = true, className = "" }) => (
  <h2
    className={`font-serif text-3xl font-normal leading-[1.1] tracking-tight sm:text-4xl lg:text-5xl ${
      dark ? "text-cream" : "text-inkdark"
    } ${className}`}
  >
    {children}
  </h2>
);
